import {
  Component,
  EventEmitter,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { IPerfil } from 'src/app/interfaces';
import { IToken } from 'src/app/interfaces/token/IToken';
import { AuthenticationService, PerfilService } from 'src/app/services';

@Component({
  selector: 'app-modal-excluir-perfil',
  templateUrl: './modal-excluir-perfil.component.html',
  styleUrls: ['./modal-excluir-perfil.component.scss']
})
export class ModalExcluirPerfilComponent implements OnDestroy {
  @Output() deletePerfil = new EventEmitter();
  @ViewChild('ModalExclui') ModalExclui: TemplateRef<any>;
  subscriptions$ = new Subscription();
  perfilToDelete: IPerfil;
  token: IToken = this.authenticationService.obterToken();

  constructor(
    private perfilService: PerfilService,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService
  ) {}

  openModal(perfil: IPerfil) {
    this.modalService.open(this.ModalExclui, { centered: true, size: 'lg' });
    this.perfilToDelete = perfil;
  }
  fecharModal() {
    this.deletePerfil.emit();
    this.modalService.dismissAll();
  }

  doDeletar() {
    this.subscriptions$.add(
      this.perfilService
        .deletePerfil({
          idUsuario: this.token?.id,
          perfilId: this.perfilToDelete?.id
        })
        .subscribe({
          complete: () => {
            this.fecharModal();
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
